import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";

const REDBLUE_LOCALES = ["zh-CN", "en", "ja"] as const satisfies readonly AppLocale[];

function cloneMessageValue(value: string | MessageTree): string | MessageTree {
  if (typeof value === "string") {
    return value;
  }
  return mergeMessageTree({}, value);
}

export function mergeMessageTree(target: MessageTree, source: MessageTree): MessageTree {
  Object.entries(source).forEach(([key, value]) => {
    const existing = target[key];
    if (value && typeof value === "object" && existing && typeof existing === "object") {
      target[key] = mergeMessageTree(existing, value);
      return;
    }
    target[key] = cloneMessageValue(value);
  });
  return target;
}

export function mergeLocaleCatalogSlices(
  slices: Array<Record<AppLocale, MessageTree>>,
): Record<AppLocale, MessageTree> {
  return Object.fromEntries(
    REDBLUE_LOCALES.map((locale) => [
      locale,
      slices.reduce<MessageTree>(
        (messages, slice) => mergeMessageTree(messages, slice[locale]),
        {},
      ),
    ]),
  ) as Record<AppLocale, MessageTree>;
}
